import type { RouteObject } from "react-router-dom";
import adminRoutes from "./admin-routes";

const routes: RouteObject[] = [...adminRoutes];

export default routes;